export default {
  sm: `
  친환경 운영을 실현하는
  풍부한 자연 에너지
  `,
};
